import { AppBootstrapStore } from './../services/app-bootstrap.service';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@umss/shared/data-access';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const appBootstrap = inject(AppBootstrapStore);
  const router = inject(Router);

  // If arriving from Corporate portal, force logout and redirect to login
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('from') === 'corporate') {
    auth.logout().subscribe();
    router.navigateByUrl('/auth/login');
    return false;
  }

  if (!appBootstrap.ready()) {
    router.navigateByUrl('/auth/login');
    return false;
  }

  const token = auth.accessToken;
  const isAuth = !!token && auth.isAuthenticated();

  if (isAuth) return true;
  router.navigateByUrl('/auth/login');
  return false;
};
